import { useState } from 'react';
import { useFileUrls } from '../../hooks/useFileUrls';

/** One stored file: an image thumbnail when it is one, otherwise a file link —
 * a stored id carries no type, so it is tried as an image first. */
function Thumb({ url, label, onRemove }: { url?: string; label: string; onRemove?: () => void }) {
  const [notImage, setNotImage] = useState(false);
  return (
    <div className="relative">
      {url ? (
        <a href={url} target="_blank" rel="noopener noreferrer" title={`Mở ${label}`} className="block overflow-hidden rounded-xl border border-slate-200 bg-slate-50">
          {notImage ? (
            <div className="flex h-24 flex-col items-center justify-center gap-1 px-2 text-slate-600">
              <i className="ri-file-text-line text-2xl" />
              <span className="text-[11px]">Mở tài liệu</span>
            </div>
          ) : (
            <img src={url} alt={label} onError={() => setNotImage(true)} className="h-24 w-full object-contain" />
          )}
        </a>
      ) : (
        <div className="flex h-24 items-center justify-center rounded-xl border border-dashed border-slate-200 bg-slate-50 text-slate-300">
          <i className="ri-loader-4-line animate-spin" />
        </div>
      )}
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          aria-label={`Bỏ ${label}`}
          className="absolute right-1 top-1 flex h-6 w-6 items-center justify-center rounded-full bg-white/90 text-slate-600 shadow"
        >
          <i className="ri-close-line" />
        </button>
      )}
    </div>
  );
}

/** Grid of stored files (images or documents), each opening full size. */
export function FileThumbnails({ fileIds, label = 'Tài liệu', onRemove }: { fileIds: string[]; label?: string; onRemove?: (fileId: string) => void }) {
  const urls = useFileUrls(fileIds);
  if (fileIds.length === 0) return null;
  return (
    <div className="grid grid-cols-3 gap-2">
      {fileIds.map((id, i) => (
        <Thumb key={id} url={urls[id]} label={`${label} ${i + 1}`} onRemove={onRemove ? () => onRemove(id) : undefined} />
      ))}
    </div>
  );
}
